import { render, staticRenderFns } from "./ciYiBianXi.vue?vue&type=template&id=4470f68d&scoped=true&"
import script from "./ciYiBianXi.vue?vue&type=script&lang=js&"
export * from "./ciYiBianXi.vue?vue&type=script&lang=js&"
import style0 from "./ciYiBianXi.vue?vue&type=style&index=0&id=4470f68d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4470f68d",
  null
  
)

export default component.exports